import React, {Component} from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import { translate } from 'react-i18next';

import './styles/trackstriplabels.css';

class TrackStripLabels extends Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  componentWillMount() {
    const { t } = this.props;
    this.texts = t('component.module.artist.misc.TrackStripLabels', {returnObjects: true});
  }

  render() {
    return (
      <div className="component-module-artist-misc-TrackStripLabels-container">
        <div className="dummyImage"/>

        <div className="title">
          <p> {this.texts.title} </p>
        </div>
        <div className="artists">
          <p> {this.texts.artists} </p>
        </div>

        <div className='stores'>
          <p> {this.texts.platforms} </p>
        </div>

        <div className="published">
          <p> {this.texts.published} </p>
        </div>

        <Tooltip title={this.texts.menu.tooltip} placement='left'>
          <IconButton>
            <Icon>
              public
            </Icon>
          </IconButton>
        </Tooltip>

      </div>
    )
  }
}
export default translate('translations')(TrackStripLabels);



// WEBPACK FOOTER //
// ./src/components/modules/artist/misc/TrackStripLabels.js